import { tasksService } from "@/_services/tasks.service"

export default {
  namespaced: true, 

  state: {
    taskList: null,
    testTask: null
  },

  mutations: {
    setTaskList(state, payload){
      state.taskList = payload
    },

    setTestTask(state, payload) {
      state.testTask = payload
    }
  },
  
  actions: {
    loadTaskList({ commit }) {
      return tasksService.getAllTasks().then(data => {
        commit('setTaskList', data.tasks)
      })
    },

    getFormTask({ commit }) {
      return tasksService.createTask().then(data => {
        commit('setTestTask', data.tasks)
      })
    },

    createTestTask({ commit }, obj) {
      commit
      return tasksService.createTestTask(obj)
    }
  }
  
}